/** @jsxImportSource @emotion/react */
import isMobile from 'ismobilejs';
import { css } from '@emotion/react';
import { SystemAuthor } from './Message.Author';
import { usePlaceholderStyles } from './Message.System.styles';
import { useCallback, useContext, useEffect, useMemo } from 'react';
import { AgentProgressContext } from '../Chat.AgentProgress/context';
import { useScrollToBottomOfMessages } from './hooks/useScrollMessageList';
import { extendedMessageWidth, fullChatExtendedMessageWidth } from './Message.styles';
import { buildTimeline } from '../Chat.AgentProgress/utils.timeline';
import { PlaceholderMessageSkeleton } from './Message.System.Placeholder';
import { AgentProgressTimeline } from '../Chat.AgentProgress/Timeline';
import { ChainOfThoughtSteps, useChainOfThoughtSteps } from './Message.System.ChainOfThought';
import { useDebounceCallback } from '@trinity/chat-components/hooks/useDebounce';
import { useIsFullPageChat } from './hooks/useIsFullPageChat';

type Props = {};

export const SystemUserInFlightResponse = (props: Props) => {
  const device = isMobile();
  const styles = usePlaceholderStyles();

  const progress = useContext(AgentProgressContext);
  const steps = useChainOfThoughtSteps();
  const scrollToBottom = useScrollToBottomOfMessages();
  const debouncedScrollToBottom = useDebounceCallback(scrollToBottom, 200);

  const timeline = useMemo(() => {
    if (!progress) return [];
    return buildTimeline(progress);
  }, [progress]);

  useEffect(() => {
    debouncedScrollToBottom({ behavior: 'instant' });
  }, [timeline, debouncedScrollToBottom]);

  const renderBody = useCallback(() => {
    if (timeline.length > 0) {
      return (
        <div>
          <AgentProgressTimeline nodes={timeline} />
        </div>
      );
    }

    if (steps.length > 0) {
      return <ChainOfThoughtSteps steps={steps} />;
    }

    return <PlaceholderMessageSkeleton />;
  }, [steps, timeline]);

  const isFullPageChat = useIsFullPageChat();

  const bodyWidth = isFullPageChat ? fullChatExtendedMessageWidth : extendedMessageWidth;

  return (
    <div css={styles.root}>
      {!device.phone && (
        <div css={styles.authorWrap}>
          <SystemAuthor animate={true} css={styles.author} />
        </div>
      )}
      <div css={css({ maxWidth: bodyWidth, width: bodyWidth, minWidth: bodyWidth })}>
        <div css={css([styles.body, css({ maxWidth: bodyWidth, width: bodyWidth, minWidth: bodyWidth })])}>
          {renderBody()}
        </div>
      </div>
    </div>
  );
};
